// extracted by css-extract-rspack-plugin
export default {"title":"JhJ1I"};